// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__36vGm","additionalInfo":"AgreementModal_additionalInfo__34RGi"};